import React from "react";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta
          name="description"
          content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming."
        />
      </Helmet>

      <div className="policy-container">
        <div className="policy-content">
          <h1>Πολιτική Απορρήτου</h1>
          <p className="last-updated">
            Τελευταία ενημέρωση: {new Date().toLocaleDateString("el-GR")}
          </p>

          <section>
            <h2>1. Εισαγωγή</h2>
            <p>
              Καλώς ήρθατε στο Fapugo Barbershop. Σεβόμαστε το απόρρητό σας και
              δεσμευόμαστε να προστατεύουμε τα προσωπικά σας δεδομένα. Αυτή η
              πολιτική απορρήτου θα σας ενημερώσει για το πώς φροντίζουμε τα
              προσωπικά σας δεδομένα όταν επισκέπτεστε τον ιστότοπό μας και θα
              σας ενημερώσει για τα δικαιώματα απορρήτου σας.
            </p>
          </section>

          <section>
            <h2>2. Δεδομένα που Συλλέγουμε</h2>
            <p>
              Ενδέχεται να συλλέγουμε, να χρησιμοποιούμε, να αποθηκεύουμε και να
              μεταφέρουμε διαφορετικά είδη προσωπικών δεδομένων σχετικά με εσάς:
            </p>
            <ul>
              <li>
                <strong>Δεδομένα Ταυτότητας:</strong> όνομα, επώνυμο
              </li>
              <li>
                <strong>Δεδομένα Επικοινωνίας:</strong> διεύθυνση email, αριθμός
                τηλεφώνου
              </li>
              <li>
                <strong>Τεχνικά Δεδομένα:</strong> διεύθυνση IP, τύπος και
                έκδοση προγράμματος περιήγησης
              </li>
              <li>
                <strong>Δεδομένα Χρήσης:</strong> πληροφορίες σχετικά με τον
                τρόπο που χρησιμοποιείτε τον ιστότοπό μας
              </li>
              <li>
                <strong>Δεδομένα Κρατήσεων:</strong> πληροφορίες σχετικά με τα
                ραντεβού και τις υπηρεσίες που επιλέγετε
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Πώς Χρησιμοποιούμε τα Δεδομένα σας</h2>
            <p>Χρησιμοποιούμε τα δεδομένα σας για τους ακόλουθους σκοπούς:</p>
            <ul>
              <li>Για τη διαχείριση και επιβεβαίωση των κρατήσεών σας</li>
              <li>Για την παροχή των υπηρεσιών μας</li>
              <li>Για επικοινωνία μαζί σας σχετικά με τα ραντεβού σας</li>
              <li>Για τη βελτίωση των υπηρεσιών μας</li>
              <li>
                Για την αποστολή ενημερώσεων και προσφορών (με τη συγκατάθεσή
                σας)
              </li>
              <li>Για τη συμμόρφωση με νομικές υποχρεώσεις</li>
            </ul>
          </section>

          <section>
            <h2>4. Κοινοποίηση Δεδομένων</h2>
            <p>
              Ενδέχεται να κοινοποιήσουμε τα προσωπικά σας δεδομένα με τρίτους
              μόνο όταν:
            </p>
            <ul>
              <li>Είναι απαραίτητο για την παροχή των υπηρεσιών μας</li>
              <li>Απαιτείται από το νόμο ή κανονιστικές αρχές</li>
              <li>Έχουμε τη ρητή συγκατάθεσή σας</li>
              <li>Είναι απαραίτητο για την προστασία των δικαιωμάτων μας</li>
            </ul>
            <p>
              Συνεργαζόμαστε με αξιόπιστους παρόχους υπηρεσιών όπως συστήματα
              κρατήσεων και επεξεργαστές πληρωμών, οι οποίοι τηρούν αυστηρά
              πρότυπα ασφαλείας.
            </p>
          </section>

          <section>
            <h2>5. Ασφάλεια Δεδομένων</h2>
            <p>
              Έχουμε θέσει σε εφαρμογή κατάλληλα μέτρα ασφαλείας για να
              αποτρέψουμε την τυχαία απώλεια, χρήση ή πρόσβαση στα προσωπικά σας
              δεδομένα με μη εξουσιοδοτημένο τρόπο. Περιορίζουμε την πρόσβαση
              στα προσωπικά σας δεδομένα σε εκείνους τους υπαλλήλους και
              συνεργάτες που έχουν επιχειρηματική ανάγκη να τα γνωρίζουν.
            </p>
          </section>

          <section>
            <h2>6. Τα Δικαιώματά σας</h2>
            <p>
              Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR), έχετε
              τα ακόλουθα δικαιώματα:
            </p>
            <ul>
              <li>
                <strong>Δικαίωμα πρόσβασης:</strong> να ζητήσετε αντίγραφα των
                προσωπικών σας δεδομένων
              </li>
              <li>
                <strong>Δικαίωμα διόρθωσης:</strong> να ζητήσετε τη διόρθωση
                ανακριβών δεδομένων
              </li>
              <li>
                <strong>Δικαίωμα διαγραφής:</strong> να ζητήσετε τη διαγραφή των
                προσωπικών σας δεδομένων
              </li>
              <li>
                <strong>Δικαίωμα περιορισμού:</strong> να ζητήσετε τον
                περιορισμό της επεξεργασίας
              </li>
              <li>
                <strong>Δικαίωμα φορητότητας:</strong> να ζητήσετε τη μεταφορά
                των δεδομένων σας
              </li>
              <li>
                <strong>Δικαίωμα εναντίωσης:</strong> να αντιταχθείτε στην
                επεξεργασία των δεδομένων σας
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Cookies</h2>
            <p>
              Ο ιστότοπός μας χρησιμοποιεί cookies για να βελτιώσει την εμπειρία
              σας. Τα cookies είναι μικρά αρχεία κειμένου που τοποθετούνται στον
              υπολογιστή σας για να συλλέγουν τυπικές πληροφορίες καταγραφής στο
              διαδίκτυο και πληροφορίες συμπεριφοράς επισκεπτών. Μπορείτε να
              ρυθμίσετε το πρόγραμμα περιήγησής σας να απορρίπτει όλα ή ορισμένα
              cookies.
            </p>
          </section>

          <section>
            <h2>8. Διατήρηση Δεδομένων</h2>
            <p>
              Θα διατηρήσουμε τα προσωπικά σας δεδομένα μόνο για όσο χρονικό
              διάστημα είναι απαραίτητο για την εκπλήρωση των σκοπών για τους
              οποίους τα συλλέξαμε, συμπεριλαμβανομένων των σκοπών ικανοποίησης
              νομικών, λογιστικών ή απαιτήσεων αναφοράς.
            </p>
          </section>

          <section>
            <h2>9. Υπηρεσίες Τρίτων</h2>
            <p>
              Ο ιστότοπός μας μπορεί να περιέχει συνδέσμους προς ιστότοπους
              τρίτων. Δεν φέρουμε ευθύνη για τις πολιτικές απορρήτου ή το
              περιεχόμενο αυτών των ιστοτόπων. Σας συνιστούμε να διαβάζετε τις
              πολιτικές απορρήτου κάθε ιστοτόπου που επισκέπτεστε.
            </p>
          </section>

          <section>
            <h2>10. Ανήλικοι</h2>
            <p>
              Οι υπηρεσίες μας δεν απευθύνονται σε άτομα κάτω των 16 ετών. Δεν
              συλλέγουμε εν γνώσει μας προσωπικά αναγνωρίσιμες πληροφορίες από
              ανηλίκους. Εάν είστε γονέας ή κηδεμόνας και γνωρίζετε ότι το παιδί
              σας μας έχει παράσχει προσωπικά δεδομένα, παρακαλούμε
              επικοινωνήστε μαζί μας.
            </p>
          </section>

          <section>
            <h2>11. Αλλαγές στην Πολιτική Απορρήτου</h2>
            <p>
              Ενδέχεται να ενημερώνουμε την πολιτική απορρήτου μας κατά καιρούς.
              Θα σας ειδοποιήσουμε για τυχόν αλλαγές δημοσιεύοντας τη νέα
              πολιτική απορρήτου σε αυτήν τη σελίδα και ενημερώνοντας την
              ημερομηνία "Τελευταία ενημέρωση".
            </p>
          </section>

          <section>
            <h2>12. Επικοινωνία</h2>
            <p>
              Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με αυτήν την πολιτική
              απορρήτου ή θέλετε να ασκήσετε τα δικαιώματά σας, παρακαλούμε
              επικοινωνήστε μαζί μας:
            </p>
            <ul>
              <li>
                Email:{" "}
                <a href="mailto:fapugo@hotmail.com">fapugo@hotmail.com</a>
              </li>
              <li>
                <a href="https://wa.me/302101234567">WhatsApp</a>
              </li>
              <li>
                <a href="https://viber.me/302101234567">Viber</a>
              </li>
              <li>Τηλέφωνο: +30 210 123 4567</li>
              <li>Διεύθυνση: Αθήνα, Ελλάδα</li>
            </ul>
          </section>

          <section>
            <h2>13. Συμμόρφωση με GDPR</h2>
            <p>
              Το Fapugo Barbershop συμμορφώνεται πλήρως με τον Γενικό Κανονισμό
              Προστασίας Δεδομένων (GDPR) της Ευρωπαϊκής Ένωσης. Η νομική βάση
              για την επεξεργασία των δεδομένων σας περιλαμβάνει:
            </p>
            <ul>
              <li>Τη συγκατάθεσή σας</li>
              <li>Την εκτέλεση σύμβασης</li>
              <li>Τη συμμόρφωση με νομικές υποχρεώσεις</li>
              <li>Τα έννομα συμφέροντά μας</li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
